import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import LandingPage from './components/LandingPage';
import CityDashboard from './components/CityDashboard';
import SelfieApp from './components/SelfieApp';
import AdminDashboard from './components/AdminDashboard';
import OnboardingFlow from './components/OnboardingFlow';
import AuthProvider from './context/AuthContext';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <motion.div
          className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/onboarding" element={<OnboardingFlow />} />
            <Route path="/dashboard" element={<CityDashboard />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/city/:cityId" element={<SelfieApp />} />
          </Routes>
        </motion.div>
      </Router>
    </AuthProvider>
  );
}

export default App;